module.exports = __webpack_public_path__ + "static/media/PolarDrift_Join.7a554d12.png";